"use client";
import { FiTag } from "react-icons/fi";
import { ICategory } from "@/interfaces/category";
import Icon from "@/components/atoms/icon";
import Link from "next/link";
import { PATH_URL } from "@/statics/static";
interface IProps {
  data: ICategory[] | undefined;
}

export const CategoryTags = (props: IProps) => {
  const { data } = props;
  return (
    <div className="t-category-tags">
      <div className="t-category-tags-item">
        <Icon component={<FiTag />} />
      </div>
      {data?.map((item: ICategory, index: number) => (
        <Link className="t-category-tags-item" key={index} href={`${PATH_URL.ARTICLE_URL}?chuyen-muc=${item?.id}`}>
          {item.name}
        </Link>
      ))}
    </div>
  );
};
